import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-width-0 min-height-0 h-100" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex text-center w-100 h-100 align-items-center"
}
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_5 = { class: "p-2" }

import {computed, ComputedRef, getCurrentInstance, onBeforeMount, onBeforeUnmount, onMounted, ref, Ref} from 'vue';
import OperatorApplicationSideMenu from "~/operatorApplication/vue/layout/OperatorApplicationSideMenu.vue";
import OperatorNodeRequest from "~/operatorApplication/ts/service/comet/OperatorNodeRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import Cobrowse from "~/operatorApplication/ts/service/comet/listeners/Cobrowse";
import AbstractEntity, {Discriminator} from "~/ts/library/AbstractEntity";
import {
    COBROWSE_CHANGE_ATTRIBUTES,
    COBROWSE_CHANGE_CLICK,
    COBROWSE_CHANGE_DOM,
    COBROWSE_CHANGE_FORMS,
    COBROWSE_CHANGE_INITIAL_HTML,
    COBROWSE_CHANGE_MOUSE_MOVE,
    COBROWSE_CHANGE_PING,
    COBROWSE_CHANGE_WINDOW_SIZE,
    COBROWSE_PING_INTERVAL,
    ICobrowseChangeAttributes,
    ICobrowseChangeClick,
    ICobrowseChangeClickValue,
    ICobrowseChangeDom,
    ICobrowseChangeForms,
    ICobrowseChangeFormsValue,
    ICobrowseChangeInitialHtml,
    ICobrowseChangeMouseMove,
    ICobrowseChangePing,
    ICobrowseChangeWindowSize,
    ICobrowseChangeWindowSizeValue,
    ICobrowseCometActionMouseMoveValue
} from "~/chat/ts/service/cobrowse/Events/ICobrowseCometChanges";
import Random from "~/ts/library/Random";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import Delay from "~/ts/library/Delay";
import BigIconFlexButton from "~/cabinet/vue/interface/button/BigIconFlexButton.vue";
import OperatorCometListener from "~/operatorApplication/ts/service/comet/OperatorCometListener";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {__} from "~/ts/library/Translate";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import ElPrompt from "~/core-ui/vue/ui/ElPrompt";
import SideMenuBigFlexButtons from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuBigFlexButtons.vue";

interface ExposeInterface {
    cobrowseDocument: ComputedRef<Document>
    sanitize: (value: string) => string,
    clearDom: (context: HTMLElement | HTMLDocument) => void,
    setState: (newState: number) => Promise<void>,
    initDocumentEventListeners: () => void,
    getClickPoint: () => HTMLDivElement,
    getCoords: (elem: HTMLElement) => { top: number, left: number },
    size: Ref<ICobrowseChangeWindowSizeValue>,
    getCursor: () => HTMLDivElement,
    scrollIfNeeded: (x: number, y: number) => void
}


const __default__ = {
    name: "OperatorApplicationCobrowse"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const STATE_LOADING = 1;
const STATE_OK = 2;
const STATE_GONE = 3;
const STATE_CANT_CONNECT = 4;

let props = __props

let emits = __emit;

let iframe = ref<HTMLIFrameElement>();
let iframeContainer = ref<HTMLDivElement>();

let sideMenuWidth = ref(600);

let pageId = ref<string>();
let size = ref<ICobrowseChangeWindowSizeValue>({
    width: 800,
    height: 600
})

let instanceId = ref<string>();

let lastPing = ref<number>();

let state = ref<number>(STATE_LOADING);

let pingTimeout = ref<number>();

let keepAliveInterval = ref<number>();
let isPointerEnabled = ref(false);
let isControlEnabled = ref(false);

let lastUserAction = ref<{
    pageId: string,
    userActionTime: number,
    lastActionTime: number
}>();

let isControlOrPointerEnabled = computed(() => {
    return isPointerEnabled.value || isControlEnabled.value;
});

let instance = getCurrentInstance().proxy;

onBeforeMount(() => {
    instanceId.value = Random.uid();

    (new OperatorApiRequest({
        url: "/buddyList/cobrowseStart",
        silent: true,
        silentError: true,
        p: {
            username: props.userdata.username
        } as OperatorApplicationApi.OperatorBuddyCobrowseStartOpenApiModel
    })).send();

    let cometListener = OperatorCometListener.get();
    addDisposableEvent(
        cometListener.disposableListenAction(new Cobrowse(props.userdata, (action, changes, actionPageId) => {
            for (let change of changes) {
                let changeType = AbstractCobrowseChange.new(change);

                let now = Date.now();
                if (changeType.isUserAction || !lastUserAction.value) {
                    lastUserAction.value = {
                        pageId: actionPageId,
                        userActionTime: now,
                        lastActionTime: now
                    };
                } else if (lastUserAction.value && lastUserAction.value.pageId == actionPageId) {
                    lastUserAction.value.lastActionTime = now;
                }
                if (!lastUserAction.value || lastUserAction.value.pageId == actionPageId || lastUserAction.value.lastActionTime < (now - COBROWSE_PING_INTERVAL - 2000)) {
                    if (pageId.value && actionPageId != pageId.value && changeType.type != COBROWSE_CHANGE_INITIAL_HTML) {
                        if (changeType.type != COBROWSE_CHANGE_PING) {
                            keepAlive(true, true, actionPageId);
                        }
                    } else {
                        pageId.value = actionPageId;
                        ping();
                        changeType.exec(expose);
                    }
                }
            }
        }))
    );

    keepAliveInterval.value = setInterval(() => {
        keepAlive(false, false, pageId.value);
    }, 60000) as any;

    keepAlive(true, true);
});


function toggleControlEnabled() {
    isControlEnabled.value = !isControlEnabled.value;
    if (isControlEnabled.value) {
        (new OperatorApiRequest({
            url: "/buddyList/cobrowseControlStart",
            silent: true,
            silentError: true,
            p: {
                username: props.userdata.username
            } as OperatorApplicationApi.OperatorBuddyCobrowseControlStartOpenApiModel
        })).send();
    }
}

onMounted(() => {
    sideMenuWidth.value = instance.$el.parentElement.offsetWidth * 0.75;
});

onBeforeUnmount(() => {
    clearInterval(keepAliveInterval.value);
    clearTimeout(pingTimeout.value);
    sendNodeRequest({
        action: "stopBrowsing",
        channel: OperatorAccountStore.login.value
    } as CometOperatorApplication.CometOperatorCobrowseDataStopOpenApiModel)
});

let canControl = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canCobrowseControl, props.userdata.siteId);
});

let scale = computed({
    get: () => {
        return OperatorApplicationConfigInstance.cobrowseScale;
    },
    set: (value: number) => {
        OperatorApplicationConfigInstance.cobrowseScale = value;
    }
});

function changeScale(delta: number) {
    let newValue = scale.value + delta;
    if (newValue >= .2 && newValue <= 2) {
        scale.value = newValue;
    }
}

function close() {
    emits('close')
}

function ping() {
    lastPing.value = (new Date()).getTime();
    if (state.value == STATE_GONE) {
        keepAlive(true, true, pageId.value);
    }
    clearTimeout(pingTimeout.value);
    pingTimeout.value = setTimeout(async () => {
        let rememberLastPing = lastPing.value;
        keepAlive(true, false, pageId.value);
        await Delay.make(5000);
        if (rememberLastPing == lastPing.value) {
            setState(STATE_GONE);
        }
    }, 15000) as any;
}

async function setState(newState: number) {
    state.value = newState
    try {
        await Delay.make(isLoading.value ? 10000 : 1, `${instanceId.value}_loading`, true);
        if (isLoading.value) {
            setState(STATE_CANT_CONNECT);
        }
    } catch (e) {

    }
}

let isLoading = computed(() => {
    return state.value == STATE_LOADING;
});

let isGone = computed(() => {
    return state.value == STATE_GONE;
});

let isCantConnect = computed(() => {
    return state.value == STATE_CANT_CONNECT;
});

let isOk = computed(() => {
    return state.value == STATE_OK;
});

function keepAlive(forceLoad: boolean, showLoading: boolean = true, pageId?: string) {
    let data: CometOperatorApplication.CometOperatorCobrowseDataKeepBrowsingAliveOpenApiModel = {
        action: "keepBrowsingAlive",
        channel: OperatorAccountStore.operator.value.login,
        forceLoad: forceLoad ? 1 : 0,
        pageID: pageId
    };
    if (showLoading) {
        setState(STATE_LOADING);
    }
    sendNodeRequest(data);
}

let cobrowseDocument = computed(() => {
    return iframe.value.contentDocument;
});

let cobrowseWindow = computed(() => {
    return iframe.value.contentWindow;
});


function scrollIfNeeded(x: number, y: number) {
    if (!isControlOrPointerEnabled.value) {
        let doc = cobrowseDocument.value;
        let body = doc.body;
        let scrollTop = Math.max(body.scrollTop, doc.documentElement.scrollTop);
        let scrollLeft = Math.max(body.scrollLeft, doc.documentElement.scrollLeft);
        let changed = false;

        let windowHeight = size.value.height;
        let windowWidth = size.value.width;

        let delta = 50;

        if (((y + delta) > scrollTop + windowHeight) || y < (scrollTop + delta)) {
            scrollTop = y - (windowHeight / 2);
            if (scrollTop < 0) {
                scrollTop = 0;
            }
            changed = true;
        }


        if (((x + delta) > scrollLeft + windowWidth) || x < (scrollLeft + delta)) {
            scrollLeft = x - windowWidth / 2;
            if (scrollLeft < 0) {
                scrollLeft = 0;
            }
            changed = true;
        }
        if (changed) {
            cobrowseWindow.value.scrollTo({
                top: scrollTop,
                left: scrollLeft,
                behavior: 'smooth'
            });
        }


        let iframeContainerLocal = iframeContainer.value;
        let containerWidth = iframeContainerLocal.offsetWidth;
        let containerHeight = iframeContainerLocal.offsetHeight;
        let containerScrollTop = iframeContainerLocal.scrollTop;
        let containerScrollLeft = iframeContainerLocal.scrollLeft;

        changed = false;

        x -= scrollLeft;
        y -= scrollTop;

        if (containerWidth < windowWidth) {
            if (((x + delta) > containerScrollLeft + containerWidth) || x < (containerScrollLeft + delta)) {
                containerScrollLeft = x - containerWidth / 2;
                if (containerScrollLeft < 0) containerScrollLeft = 0;
                changed = true;
            }
        }

        if (containerHeight < windowHeight) {
            if (((y + delta) > containerScrollTop + containerHeight) || y < (containerScrollTop + delta)) {
                containerScrollTop = y - containerHeight / 2;
                if (containerScrollTop < 0) containerScrollTop = 0;
                changed = true;
            }
        }


        if (changed) {
            iframeContainerLocal.scrollTo({
                top: containerScrollTop,
                left: containerScrollLeft,
                behavior: "smooth"
            });
        }
    }
}


function getCursor(): HTMLDivElement {
    let id = `cursor-${instanceId.value};`
    var cursor: HTMLDivElement = cobrowseDocument.value.getElementById(id) as any;
    if (!cursor) {
        cursor = cobrowseDocument.value.createElement("div");
        cursor.id = id;
        let style = cursor.style;
        style.position = "absolute";
        style.zIndex = "2147483647";
        style.transition = "all 0.3s ease-in-out";
        style.width = "20px";
        style.height = "29px";
        style.background = "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAdCAYAAACqhkzFAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABPNJREFUeNqclWtsFFUUx/937p2Zfcy6bEvB3QK11WgTpbXlHXkYmygkGotfwNigBlD5gkEgPkLVkKBNDKgoKKKVZ8CqpFIpCE1RiE0q0X5Q0WIFSp+7rVtCpdt9zFzPzLaGKgrlJmd35t47v/s/59x7LisqKgoJwaulxBTLMrcBbA2AAdxgUxSFvWNZclqku0+JXY6vECqvp37fDQNTKavINC2ULSuBy6uhq613Bimuo7HsGwKSXertjWLB/HnYVllOPSbCHX9MVzXxLY1NGDWQMQbLBH4724pphSV4r2o9wC10ng3ncJWfoDkFo1QobSosBvyJNtwzaxa21rwBf+gmdLd05VJMG8AwfTQu03zAot8EwVtwAZMLClFRXYFAdgY6mtu8CudHwNj91w20W2rYJNCMc8jNycfGwx9iYmEuOs6cDyhcqSHowusByrRCiaRjdg9lW0aQHboVFV/uxS2Fd6D1x180ivcBsievy2WTYAlHJQOH5li77ETACGJTbS2ml87HhdOn7eUrGVOeu7bLpDPuKOVgUiW8Ci519MgwDI8P63fux4yFpWj99WfaFcmNFNf1/+uySShbHWMapEJGbtvPClzoln2QKseGPXuxYOnTaDtzBqlEvJyO2aZ/70PH4XRCJAS9qfTAKQ6klKmkVoAzHVHLcua8tPlNlD7zLNrPtSA+OLCKc7F9BFASxsmDI1ajh7S7NgyWILDm9KuWgmgUuBgD1m58HWUrX0VXRytisf5lisJ3DwOFo49KjZRKWt0QFKSMhike6X87/SqtGSNovw6semUtfPoY7PrgZVqcl2maS5XSWiwccUzanY4yx20Hog29k1qCjXER0E3dBrEvktIu4Imly+HTxqOycrWNWaSqrpgYdpgNu0xAi2KoMTd0ZjiZTwwkUfP5AVzqDiNxeRB9kS5c7InYmYTL7YXhCyCRHLQ5fMhlOBDYish1TfFAN10Ur374DB+8fhVNdUdwaN8OZE8KSosSRCeHkYEJQXMyoQp9H7m8ROBvhZwWZNAVPyYigG1bN6PhYA1eq6mF4VLx2Orn0XTiGCnyMK/P/xmFvXbo2z4pZSfBTiEd7XQzaTe6qVBTiLBr905UrlvnLNL8XSMCc2fjttvzMbPkIZw8UgWP4SeI9fF/bWwqhym4hYFx9PLRls14+6kVyAyGoHlVHNuzHwkKpEYzH3j4UWhuA8lkfDntp6tWH4XkCk3TkZWbg/dJ2fY1LyKYlxczAoFGj88fP1VXS2f4dycBBQVzMbloJvqiYXDOr1okeDAUWuk2jKxzP53G8f2fwp+ZAXp/y0ylFukuz4M94QsTDG8AU2fMgSClXAbwzckquHXPXYzzL4jRPQIYyg5NokzPDtMV4Da80A3vFss0VzlViCnjFAUl0UgPiqc+Ajd3IZSZh+9/+Bqd3S0wvP4YefjVSIXBoH1tJjW3S1AFKZeWrBgepMnNmu5a0t7abIzPCuLO/CkY6wHG+gOobzgKIUSBoohqmtozIilkG8jmke3+R0gidII+EZqK43UHQTlCJt3YWf48jM24GfHEoJcK7n1XfsCKi4uvUdTZ3alUvCmRjOPxxS+gtzeCQ8d2QKVFNKEPUhW4lyY1jgLoxPIw7bv50b4IUmacTkYAHrfvPG3ulRSYmlEqdNokskpLWnPoyq2nBd6l+B4F0lfQle0vAQYAPWnVRXiDkCkAAAAASUVORK5CYII=') no-repeat";
        cobrowseDocument.value.body.appendChild(cursor);
    }
    return cursor;
}

function sanitize(html: string): string {
    html = html.replace(/<script.*?>.*?<\/script>/igm, '');
    return html.replace(/<[^>]+/gi, function (match) {
        return match.replace(/ on\w+\s?=/gi, ' removedEvent=');
    });
}

function getCoords(elem: HTMLElement): { top: number, left: number } {
    var box = elem.getBoundingClientRect();

    var body = cobrowseDocument.value.body;
    var docEl = cobrowseDocument.value.documentElement;

    let win = cobrowseWindow.value;
    var scrollTop = win.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = win.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return {top: Math.round(top), left: Math.round(left)};
}

function getClickPoint() {
    let document = cobrowseDocument.value;
    let className = `browser-click-point-${instanceId.value}`;

    let style = document.getElementById(className);
    if (!style) {
        let style = document.createElement("style");
        style.id = className;
        style.innerText = `.${className} {
                z-index:10000000;
                position:absolute;
                border: 3px solid #4aa3df;
                box-shadow:0 0 0 2px #ffffff;
                border-radius: 32px;
                height: 20px;
                width: 20px;
                animation: pulsate .6s ease-out;
                animation-iteration-count: 3;
                opacity: 0
            }
            @keyframes pulsate {
                0% {
                    transform: scale(0.1, 0.1);
                    opacity: 0.0;
                }
                50% {
                    opacity: 1.0;
                }
                100% {
                    transform: scale(1.2, 1.2); opacity: 0.0;
                }
            }`;
        document.head.appendChild(style);
    }
    let points = document.getElementsByClassName(className);
    if (points.length > 2) {
        document.body.removeChild(points[0]);
    }
    let point = document.createElement("div");
    point.className = className;
    document.body.appendChild(point);
    return point;
}

function clearDom(context: HTMLElement | HTMLDocument) {
    let iframes = context.querySelectorAll("iframe");
    for (let i = 0; i < iframes.length; i++) {
        (iframes[i] as HTMLIFrameElement).src = "about:blank";
    }
    let inputs = context.querySelectorAll("input[type=text][name], input[type=password][name]");
    for (let i = 0; i < inputs.length; i++) {
        let input: HTMLInputElement = inputs[i] as any;
        input.setAttribute("original-name", input.name);
        input.setAttribute("name", Random.uid());
    }
}

function getFullPath(element: HTMLElement): string {
    let path = [];
    while (element.parentElement) {
        let tagName = element.tagName;
        if (element === element.ownerDocument.documentElement) {
            path.unshift(element.tagName);
            break
        } else {
            let parent = element.parentElement;
            for (let index = 0; index < parent.children.length; index++) {
                if (parent.children[index] === element) {
                    tagName += `:nth-child(${index + 1})`;
                    break
                }
            }
            element = parent;
            path.unshift(tagName)
        }
    }
    return path.join(" > ");
}

function initDocumentEventListeners() {
    let doc = cobrowseDocument.value;
    doc.addEventListener("mouseover", e => {
        if (isPointerEnabled.value) {
            let target = e.target as HTMLElement;
            let outline = target.style.outline;
            target.setAttribute("old-outline", outline);
            target.style.setProperty("outline", "3px dashed #007bff", "important");
        }
    });

    doc.addEventListener("mouseout", e => {
        let target = e.target as HTMLElement;
        let outline = target.getAttribute("old-outline");
        if (outline != null) {
            target.style.setProperty("outline", outline);
            target.removeAttribute("old-outline");
        }
    });

    let mouseMoveTimeout: number;
    let mouseMoveEvent: MouseEvent;
    doc.addEventListener("mousemove", async e => {
        if (isControlEnabled.value) {
            mouseMoveEvent = e;
            if (!mouseMoveTimeout) {
                mouseMoveTimeout = setTimeout(() => {
                    mouseMoveTimeout = null;
                    sendNodeRequest({
                        operatorId: OperatorAccountStore.operator.value.id,
                        target: getFullPath(mouseMoveEvent.target as HTMLElement),
                        offsetX: mouseMoveEvent.offsetX,
                        offsetY: mouseMoveEvent.offsetY,
                        action: "mousemove"
                    } as CometOperatorApplication.CometOperatorCobrowseDataMouseMoveOpenApiModel)
                }, 500) as any;
            }
        }
    }, {passive: true});

    doc.addEventListener("click", async e => {
        e.preventDefault();
        e.stopPropagation();
        if (isPointerEnabled.value) {
            try {
                let result = await ElPrompt(__("Введите текст подсказки для пользователя"), __("Ожидаем ввод текста"));
                let value: string = (result as any).value;
                if (!value || !value.trim().length) {
                    value = __("Обратите внимание сюда");
                }
                let payload: CometOperatorApplication.CometOperatorCobrowseDataPointerOpenApiModel = {
                    action: "pointer",
                    target: getFullPath(e.target as HTMLElement),
                    text: value,
                    operatorId: OperatorAccountStore.operator.value.id
                };
                sendNodeRequest(payload);

                isPointerEnabled.value = false;
            } catch (e) {

            }
        }

        if (isControlEnabled.value) {
            try {
                sendNodeRequest({
                    action: "click",
                    target: getFullPath(e.target as HTMLElement),
                    offsetX: e.offsetX,
                    offsetY: e.offsetY
                } as CometOperatorApplication.CometOperatorCobrowseDataClickOpenApiModel);
            } catch (e) {

            }
        }
    }, {capture: true})

    let formsListener = (e: KeyboardEvent) => {
        if (isControlEnabled.value) {
            if (OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canCobrowseViewFormValues)) {
                var $el = e.target as HTMLInputElement | HTMLSelectElement;
                if (($el as any).timeout == null) {
                    let delay = e.type === "change" ? 10 : 1000;
                    ($el as any).timeout = setTimeout(() => {
                        ($el as any).timeout = null;
                        let value: any;
                        let tag = $el.tagName.toLowerCase();
                        if (tag === "input") {
                            let type = $el.getAttribute("type");

                            if (type && ["radio", "checkbox"].indexOf(type.toLowerCase()) > -1) {
                                value = ($el as HTMLInputElement).checked ? 1 : 0;
                            } else {
                                value = $el.value;
                            }
                        } else if (tag === "textarea") {
                            value = $el.value;
                        } else if (tag === "select") {
                            value = ($el as HTMLSelectElement).selectedIndex;
                        }

                        if (value != null) {
                            sendNodeRequest({
                                action: "forms",
                                target: getFullPath($el),
                                value
                            } as CometOperatorApplication.CometOperatorCobrowseDataFormsOpenApiModel)
                        }
                    }, delay);
                }
            }
        } else {
            if ((e.ctrlKey || e.metaKey) && e.keyCode === 67) {
                //cmd + c
            } else {
                e.preventDefault();
            }
        }
    };

    doc.addEventListener("keyup", formsListener);
    doc.addEventListener("keydown", formsListener);
    doc.addEventListener("change", formsListener);
}


function sendNodeRequest(data: CometOperatorApplication.CometOperatorCobrowseDataOpenApiModel) {
    let body: CometOperatorApplication.CometOperatorCobrowseBodyOpenApiModel = {
        channelIds: [props.userdata.cometChannelId],
        data
    };
    (new OperatorNodeRequest("/operatorCobrowse"))
        .setBody(body)
        .send();
}

let expose: ExposeInterface = {
    cobrowseDocument,
    sanitize,
    clearDom,
    setState,
    initDocumentEventListeners,
    getClickPoint,
    getCoords,
    size,
    getCursor,
    scrollIfNeeded
};


class AbstractCobrowseChange extends AbstractEntity {
    type: string | any;

    protected getDiscriminator(): Discriminator {
        return (new Discriminator("type", {
            [COBROWSE_CHANGE_INITIAL_HTML]: InitialHtmlCobrowseChange,
            [COBROWSE_CHANGE_DOM]: DomCobrowseChange,
            [COBROWSE_CHANGE_PING]: PingCobrowseChange,
            [COBROWSE_CHANGE_FORMS]: FormsCobrowseChange,
            [COBROWSE_CHANGE_CLICK]: ClickCobrowseChange,
            [COBROWSE_CHANGE_MOUSE_MOVE]: MouseMoveCobrowseChange,
            [COBROWSE_CHANGE_WINDOW_SIZE]: WindowSizeCobrowseChange,
            [COBROWSE_CHANGE_ATTRIBUTES]: AttributesCobrowseChange
        }));
    }

    get isUserAction(): boolean {
        return false;
    }

    exec(instance: ExposeInterface) {
    }
}

class InitialHtmlCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangeInitialHtml {
    html: string;

    exec(instance: ExposeInterface) {
        let doc = instance.cobrowseDocument.value;
        doc.open();
        try {
            doc.write(instance.sanitize(this.html));
            doc.close();
            instance.clearDom(doc);
            instance.setState(STATE_OK);
            instance.initDocumentEventListeners();
        } catch (e) {

        }
    }
}

class DomCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangeDom {
    html: string;
    path: string;

    exec(instance: ExposeInterface) {
        let element: HTMLElement = instance.cobrowseDocument.value.querySelector(this.path);
        if (element) {
            element.innerHTML = instance.sanitize(this.html);
            instance.clearDom(element);
        }
    }
}

class AttributesCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangeAttributes {
    attributeName: string;
    path: string;
    value: string;

    exec(instance: ExposeInterface) {
        let target: HTMLElement = instance.cobrowseDocument.value.querySelector(this.path);
        if (target) {
            if (this.value == null) {
                target.removeAttribute(this.attributeName);
            } else {
                if (this.attributeName.toLowerCase().indexOf("on") !== 0) {
                    target.setAttribute(this.attributeName, this.value);
                }
            }
        }
    }
}

class PingCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangePing {
    exec(instance: ExposeInterface) {

    }
}

class FormsCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangeForms {
    value: ICobrowseChangeFormsValue[];

    exec(instance: ExposeInterface) {
        let doc = instance.cobrowseDocument.value;
        for (let data of this.value) {
            let target: HTMLElement = doc.querySelector(data.target);
            if (target) {
                let tag = target.tagName.toLowerCase();
                let type = target.getAttribute("type");
                if (type != null) {
                    type = type.toLowerCase();
                }
                if (type === "radio") {
                    if (data.value === 1) {
                        let name = target.getAttribute("name");
                        if (name != null) {
                            let inputs = doc.querySelectorAll(`input[name="${name}"][type="radio"]:checked`);
                            for (let i = 0; i < inputs.length; i++) {
                                (inputs[i] as HTMLInputElement).checked = false;
                            }
                        }
                        (target as HTMLInputElement).checked = true;
                    } else {
                        (target as HTMLInputElement).checked = false;
                    }
                } else if (type === "checkbox") {
                    (target as HTMLInputElement).checked = data.value === 1;
                } else if (tag === "textarea" || tag === "input") {
                    if (!OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canCobrowseViewFormValues)) {
                        if (typeof data.value === "string") {
                            data.value = "*".repeat(data.value.length)
                        }
                    }
                    (target as HTMLInputElement).value = data.value;
                } else if (tag === "select") {
                    (target as HTMLSelectElement).selectedIndex = data.value;
                }
            }
        }
    }
}

class ClickCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangeClick {
    value: ICobrowseChangeClickValue[];

    exec(instance: ExposeInterface) {
        for (let row of this.value) {
            let target: HTMLElement = instance.cobrowseDocument.value.querySelector(row.target);
            if (target) {
                let point = instance.getClickPoint();
                let offset = instance.getCoords(target);
                point.style.top = `${offset.top + row.offsetY - 12}px`;
                point.style.left = `${offset.left + row.offsetX - 12}px`;
            }
        }
    }

    get isUserAction(): boolean {
        return true;
    }
}

class MouseMoveCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangeMouseMove {
    value: ICobrowseCometActionMouseMoveValue;

    exec(instance: ExposeInterface) {
        let style = instance.getCursor().style;
        let x = this.value.offsetX;
        let y = this.value.offsetY;

        let target: HTMLElement = instance.cobrowseDocument.value.querySelector(this.value.target);
        if (target) {
            let offset = instance.getCoords(target);
            y += offset.top;
            x += offset.left;
            style.top = `${y}px`;
            style.left = `${x}px`;
            instance.scrollIfNeeded(x, y);
        }
    }

    get isUserAction(): boolean {
        return true;
    }
}

class WindowSizeCobrowseChange extends AbstractCobrowseChange implements ICobrowseChangeWindowSize {
    value: ICobrowseChangeWindowSizeValue[];

    exec(instance: ExposeInterface) {
        instance.size.value = this.value[this.value.length - 1];
    }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OperatorApplicationSideMenu, {
    right: "",
    class: "root",
    width: _unref(sideMenuWidth),
    "onUpdate:width": _cache[4] || (_cache[4] = ($event: any) => (_isRef(sideMenuWidth) ? (sideMenuWidth).value = $event : sideMenuWidth = $event)),
    "min-width": 320
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "flex-fill iframe-container",
          ref_key: "iframeContainer",
          ref: iframeContainer
        }, [
          _withDirectives(_createElementVNode("div", {
            class: "overflow-hidden iframe-wrapper",
            style: _normalizeStyle({
                        width: `${_unref(size).width * _unref(scale)}px`,
                        height: `${_unref(size).height * _unref(scale)}px`
                    })
          }, [
            _createElementVNode("iframe", {
              ref_key: "iframe",
              ref: iframe,
              style: _normalizeStyle({
                            width: `${_unref(size).width}px`,
                            height: `${_unref(size).height}px`,
                            transform: `scale(${_unref(scale)})`
                        }),
              sandbox: "allow-same-origin"
            }, null, 4)
          ], 4), [
            [_vShow, _unref(isOk)]
          ]),
          (!_unref(isOk))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_unref(isLoading))
                    ? (_openBlock(), _createBlock(MyLoader, {
                        key: 0,
                        big: ""
                      }))
                    : (_unref(isGone) || _unref(isCantConnect))
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_unref(isGone) ? _unref(__)("Посетитель покинул страницу") : _unref(__)("Не удалось установить подключение")), 1))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SideMenuBigFlexButtons, {
            class: "mt-0 cobrowse-buttons",
            "without-padding": ""
          }, {
            default: _withCtx(() => [
              _createVNode(BigIconFlexButton, {
                icon: "sync",
                descr: _unref(__)('Обновить'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (keepAlive(true, true))),
                "min-width": "6em"
              }, null, 8, ["descr"]),
              _createVNode(BigIconFlexButton, {
                icon: "search-minus",
                descr: _unref(__)('Уменьшить'),
                "min-width": "6em",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeScale(-.1)))
              }, null, 8, ["descr"]),
              _createVNode(BigIconFlexButton, {
                icon: "search-plus",
                descr: _unref(__)('Увеличить'),
                "min-width": "6em",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changeScale(.1)))
              }, null, 8, ["descr"]),
              _createVNode(BigIconFlexButton, {
                icon: "bullseye-pointer",
                descr: _unref(__)('Указка'),
                class: _normalizeClass({selected: _unref(isPointerEnabled)}),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(isPointerEnabled) //@ts-ignore
 ? isPointerEnabled.value = !_unref(isPointerEnabled) : isPointerEnabled = !_unref(isPointerEnabled))),
                "min-width": "6em"
              }, null, 8, ["descr", "class"]),
              (_unref(canControl) || _unref(isControlEnabled))
                ? (_openBlock(), _createBlock(BigIconFlexButton, {
                    key: 0,
                    icon: "gamepad",
                    descr: _unref(__)('Управление'),
                    class: _normalizeClass({selected: _unref(isControlEnabled)}),
                    onClick: toggleControlEnabled,
                    "min-width": "6em"
                  }, null, 8, ["descr", "class"]))
                : _createCommentVNode("", true),
              _createVNode(BigIconFlexButton, {
                onClick: close,
                icon: "times",
                descr: _unref(__)('Закрыть'),
                "min-width": "6em"
              }, null, 8, ["descr"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["width"]))
}
}

})